<script setup>
import { computed } from 'vue';

const props = defineProps({
  percent: { type: Number, default: null },
  state: { type: String, default: 'in_progress' },
});

const RADIUS = 52;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const hasData = computed(
  () => props.state !== 'no_data' && props.percent !== null
);

const capped = computed(() =>
  hasData.value ? Math.min(Math.max(props.percent, 0), 100) : 0
);

const dashArray = computed(
  () => `${(CIRCUMFERENCE * capped.value) / 100} ${CIRCUMFERENCE}`
);

// Mesmas faixas da barra de progresso: vermelho < 50%, amarelo até 99%, verde a partir de 100%.
const strokeClass = computed(() => {
  if (props.state === 'achieved' || capped.value >= 100) {
    return 'stroke-n-teal-9';
  }
  return capped.value >= 50 ? 'stroke-n-amber-9' : 'stroke-n-ruby-9';
});
</script>

<template>
  <div class="relative flex items-center justify-center size-28 shrink-0">
    <svg viewBox="0 0 120 120" class="size-full -rotate-90">
      <circle
        cx="60"
        cy="60"
        :r="RADIUS"
        fill="none"
        stroke-width="10"
        class="stroke-n-alpha-2"
      />
      <circle
        cx="60"
        cy="60"
        :r="RADIUS"
        fill="none"
        stroke-width="10"
        stroke-linecap="round"
        :stroke-dasharray="dashArray"
        :class="strokeClass"
      />
    </svg>
    <span class="absolute text-2xl font-semibold text-n-slate-12">
      {{ hasData ? `${Math.round(percent)}%` : '—' }}
    </span>
  </div>
</template>
